(() => {
  const shuffle = values => {
    const result = [...values];
    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  };
  const nextPair = (cards, previous, pending) => {
    let bag = pending.filter(card => !previous.includes(card));
    if (bag.length < 2) {
      const rest = shuffle(cards.filter(card => !previous.includes(card) && !bag.includes(card)));
      bag = [...bag, ...rest];
    }
    if (bag.length < 2) bag = [...bag, ...shuffle(cards.filter(card => !bag.includes(card)))];
    return { selected: bag.slice(0, 2), pending: bag.slice(2) };
  };
  const send = (action, itemId = '', result = '') => {
    if (typeof window.Shopify?.analytics?.publish !== 'function') return;
    try { Promise.resolve(window.Shopify.analytics.publish('mp_feature_interaction', {feature:'recipe',action,item_id:String(itemId).slice(0,160),result:String(result).slice(0,80)})).catch(() => {}); } catch (_) {}
  };
  const init = () => {
    document.querySelectorAll('[data-mp-recipes]').forEach(root => {
      if (root.dataset.recipeReady) return;
      root.dataset.recipeReady = 'true';
      const cards = [...root.querySelectorAll('[data-mp-recipe-card]')];
      const button = root.querySelector('[data-mp-recipe-shuffle]');
      const grid = root.querySelector('[data-mp-recipe-grid]');
      const status = root.querySelector('[data-mp-recipe-status]');
      if (cards.length < 3) return;
      let previous = [], pending = shuffle(cards);
      const change = announce => {
        const pair = nextPair(cards, previous, pending);
        previous = pair.selected; pending = pair.pending;
        cards.forEach(card => { card.hidden = !previous.includes(card); });
        grid.removeAttribute('data-mp-recipe-ready');
        requestAnimationFrame(() => grid.setAttribute('data-mp-recipe-ready','true'));
        if (announce) {
          status.textContent = previous.map(card => card.querySelector('h3').textContent).join('、');
          send('shuffle','',previous.map(card=>card.dataset.recipeId).join(',').slice(0,80));
        }
      };
      change(false); button.hidden = false;
      button.addEventListener('click', () => change(true));
    });
  };
  if (!window.mpRecipeEventsReady) {
    window.mpRecipeEventsReady = true;
    document.addEventListener('click',event => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('[data-mp-recipes] a[href],a[data-mp-recipe-product]');
      if (!link) return;
      const handle = link.dataset.productHandle || link.getAttribute('href').split('/').filter(Boolean).at(-1) || '';
      send(link.hasAttribute('data-mp-recipe-product')?'product_click':'recipe_open',handle);
      if (link.hasAttribute('data-mp-recipe-product') && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true) {
        try { sessionStorage.setItem('mp_discovery_source_v1',JSON.stringify({feature:'recipe',itemId:handle,time:Date.now()})); } catch (_) {}
      }
    });
    document.addEventListener('shopify:section:load',init);
  }
  init();
})();
